import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            companies: []
        }
    },
    methods: {
        load: load,
        editCompany: editCompany,
        addCompany: addCompany,
        deleteCompany: deleteCompany
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.load()
    }
}


function load() {
    let _self = this;

    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.companies = response.data
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function deleteCompany(company){
    let _self = this;

    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da uklonite saradnika: " + company.name +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteCompanyPayments(company.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno obrisan saradnik. Svi korisnici su izmenjeni koji su pripadali ovom saradniku.', 'success')
                _self.load();
            })
            .catch(error => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });


}

function editCompany(company) {
    this.$router.push('/add-company-payment?id=' + company.id + '&name='+company.name)
}

function addCompany() {
    this.$router.push('/add-company-payment')
}


// WEBPACK FOOTER //
// ./src/components/CompanyPayment/CompanyPayment.js